module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00406.e47c15f4.jpg";